package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.setMeta
import com.anjuros.website.components.setSpamJs
import com.anjuros.website.redesign.components.RdScrollReveal
import com.anjuros.website.redesign.components.SiteFooter
import com.anjuros.website.redesign.components.SiteHeader
import com.anjuros.website.redesign.components.rdNavItems
import com.anjuros.website.redesign.components.setJsonLd
import com.anjuros.website.redesign.sections.home.HomeContactSection
import com.anjuros.website.redesign.sections.home.HomeDesignsSection
import com.anjuros.website.redesign.sections.home.HomeFaqSection
import com.anjuros.website.redesign.sections.home.HomeHeroSection
import com.anjuros.website.redesign.sections.home.HomeHowItWorksSection
import com.anjuros.website.redesign.sections.home.HomeIncludedSection
import com.anjuros.website.redesign.sections.home.HomePortalSection
import com.anjuros.website.redesign.sections.home.HomeTradesSection
import com.anjuros.website.redesign.sections.home.HomeWhySection
import com.anjuros.website.redesign.sections.home.homeStructuredData
import com.anjuros.website.redesign.styles.RdPageStyle
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main

@Page
@Composable
fun HomePage() {
    val title = LocalText(RdText.HOME_META_TITLE)
    val description = LocalText(RdText.HOME_META_DESCRIPTION)
    val structuredData = homeStructuredData()

    LaunchedEffect(Unit) {
        setMeta(title, description)
        setJsonLd("ld-home", structuredData)
        changeMode(UiMode.NORMAL)
        setSpamJs()
    }

    Div(RdPageStyle.toModifier().toAttrs()) {
        SiteHeader(rdNavItems(), ctaPath = "#contact")
        Main(Modifier.id("home").toAttrs()) {
            HomeHeroSection()
            HomeIncludedSection()
            HomeDesignsSection()
            HomeTradesSection()
            HomeHowItWorksSection()
            HomePortalSection()
            HomeWhySection()
            HomeFaqSection()
            HomeContactSection()
        }
        SiteFooter()
        RdScrollReveal()
    }
}
